"use client";

import React, { useState } from "react";
import styles from "./drainproof-transacting.module.scss";
import Image from "next/image";
import icon from "@public/icon_white.png";
import { Input } from "antd";
import PagePositioner from "@/components/layout/page-positioner/page-positioner";
import FloatingButterflies from "@/components/layout/floating-butterflies/floating-buttflies";
import BlessButton from "@/components/layout/button/green-outline-btn";
import Link from "next/link";

const DrainProofTransacting = () => {
  const [email, setEmail] = useState<string>("");

  const handleSubscribe = (): void => {
    console.log(email);
  };

  return (
    <div className={styles.container}>
      <div className={styles.containerBackground} />
      <PagePositioner>
        <div className={styles.block}>
          {/* Needs to change opacity when breakpoint for mobile  */}
          <FloatingButterflies />
          <div className={styles.col}>
            <div className={styles.header}>
              Drainproof
              <br /> <span>transacting</span>
            </div>
            <div className={styles.subheader}>
              Value stored on{" "}
              <strong>
                <i>other</i>
              </strong>{" "}
              chains
            </div>
            <div className={styles.paragraph}>
              Thanks to the value being stored on other chains, transacting on Blessnet ensures an experience that is undrainable. Making on-chain
              safer than ever before.
            </div>
            <Link href="https://docs.bless.net/papers-and-articles/whitepaper#value-bearing-vs-transaction-processing">
              <BlessButton buttonType="outlined" color="white">
                See more
              </BlessButton>
            </Link>
          </div>
        </div>
      </PagePositioner>
    </div>
  );
};

export default DrainProofTransacting;
